<template>
    <div id="typing_loader">
        <svg version="1.1" id="L4" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
        viewBox="0 0 100 100" enable-background="new 0 0 0 0" xml:space="preserve">
            <circle :fill="bulletsColor" stroke="none" cx="6" cy="50" r="6">
                <animate
                attributeName="opacity"
                dur="1s"
                values="0;1;0"
                repeatCount="indefinite"
                begin="0.1"/>    
            </circle>
            <circle :fill="bulletsColor" stroke="none" cx="26" cy="50" r="6">
                <animate
                attributeName="opacity"
                dur="1s"
                values="0;1;0"
                repeatCount="indefinite" 
                begin="0.2"/>       
            </circle>
            <circle :fill="bulletsColor" stroke="none" cx="46" cy="50" r="6">
                <animate
                attributeName="opacity"
                dur="1s"
                values="0;1;0"
                repeatCount="indefinite" 
                begin="0.3"/>     
            </circle>
        </svg>        
        <span>digitando</span>
    </div>    
</template>

<script>
export default {
    name: 'typing-loader',

    data: () =>({
        bulletsColor: '#000'
    })
}
</script>

<style lang="scss" scoped>
#typing_loader{
    width: 100px;
    display: flex;
    flex-direction: column;
    margin: 0 auto;

    span{
        text-transform: uppercase;
        letter-spacing: 2px;
        color: #7c7c7c;
        font-size: 10px;
        position: relative;
        top: -32px;
        left: -7px;
    }
}
</style>
